import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import swal from 'sweetalert2';
import { BillingService } from '../../../services/billing.service';
import { getParamFromAncestorRoute, getQueryParamFromAncestorRoute } from '../../../utilities/route.utilities';


@Component({
    selector: 'cumulative-credit-status-grid-item',
    templateUrl: './cumulative-credit-status-grid-item.component.html',
})
export class CumulativeCreditStatusGridItemComponent implements OnInit, OnDestroy {

    subscriptions: any[] = [];
    timePeriod: number = 1;
    clientId: number;
    siteId: number;
    agedDebt: any[] = [];
    hasData: boolean = false;
    hasLoading: boolean = true;
    constructor(
        private billingService: BillingService,
        private route: ActivatedRoute,
        private router: Router) {
        this.subscriptions.push(router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.ngOnInit();
            }
        }));
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    onInfoClick() {
        swal({
            title: 'Total portfolio credit status',
            html: '<p style="text-align: left;">This chart displays the total credit status across your portfolio.</p>\
              <p style="text-align: left;">It shows both negative and positive totals.</p>\
                <p style="text-align: left;"> This indicates the overall behavior of your PAYG portfolio consumers.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
